
import { useQueryClient } from "@tanstack/react-query";
import { useShops } from "@/hooks/useShops";
import { updateRapidInsertFlag } from "@/services/shopping/offline-lists.service";
import usePremiumFeatures from "@/hooks/usePremiumFeatures";

interface UseShoppingListActionsProps {
  queryClient: ReturnType<typeof useQueryClient>;
  listId: string | null;
}

export function useShoppingListActions({ queryClient, listId }: UseShoppingListActionsProps) {
  const { associateListWithShop } = useShops();
  const { tryUseFeature } = usePremiumFeatures();
  
  const handleRapidInsertChange = async (newValue: boolean) => {
    if (!listId) return;
    
    try {
      await updateRapidInsertFlag(listId, newValue);
      await queryClient.invalidateQueries({ queryKey: ['shopping-list', listId] });
    } catch (error) {
      console.error("Errore nell'aggiornare rapidInsert:", error);
    }
  };

  const handleItemAddSuccess = () => {
    if (!listId) return;
    
    // Aggiorna i dati della lista
    queryClient.invalidateQueries({ queryKey: ['shopping-list', listId] });
    queryClient.invalidateQueries({ queryKey: ['shopping-items', listId] });
  };
  
  // ✅ FIX: Handle shop selection con oggetto corretto
  const handleShopSelect = async (shopId: string | null) => {
    if (!listId) return;

    if (!tryUseFeature('list_store_binding', { showToast: true })) {
      return;
    }

    try {
      await associateListWithShop({
        listId,
        shopId
      });
    } catch (err) {
      console.error('associateListWithShop failed', err);
    }
  };

  return {
    handleRapidInsertChange,
    handleItemAddSuccess,
    handleShopSelect
  };
}
